import { render, staticRenderFns } from "./OnboardingUserType.vue?vue&type=template&id=75d4acd0&scoped=true&"
import script from "./OnboardingUserType.vue?vue&type=script&lang=js&"
export * from "./OnboardingUserType.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingUserType.vue?vue&type=style&index=0&id=75d4acd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d4acd0",
  null
  
)

export default component.exports